export default __webpack_public_path__ + "static/media/gallery_13.ef99c9c7.jpg";